var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CustomersImageList"},[_c('h2',[_vm._v(_vm._s(_vm.$t('catering.customersSectionTitle')))]),_c('image-list',{attrs:{"imageList":_vm.customers,"rows":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }